"use client";
import Image from "next/image";
import React from "react";
import FlatGlassBanner from "../../../public/assets/background/liquor_banner.jpg";
import { IoCaretForward } from "react-icons/io5";
import CtbBanner from "../../../public/assets/background/liquor_why_bg.jpg";
import GlassImg from "../../../public/assets/background/liquor_bg.jpg";
import Link from "next/link";
import { HiHome } from "react-icons/hi2";
import { BsPatchCheckFill } from "react-icons/bs";
import { GiBeerBottle, GiGlobe, GiWineBottle } from "react-icons/gi";
import MoreToExploreMobile from "@/components/product/ExploreMoreMobile";
import MoreToExplore from "@/components/product/ExploreMore";
import { TbGlassFull } from "react-icons/tb";
import LiquorClients from "@/components/product/liquorClients/LiquorClients";
import LiquorClientsMobile from "@/components/product/liquorClients/LiquorClientsMobile";

const LiquorBottles = () => {
  const categories = [
    {
      title: "Whiskey & Rum Packaging",
      icon: <GiBeerBottle className="text-3xl text-red-500" />,
    },
    {
      title: "Vodka, Gin & Clear Spirits",
      icon: <TbGlassFull className="text-3xl text-red-500" />,
    },
    {
      title: "Craft Distilleries & Premium Labels",
      icon: <GiWineBottle className="text-3xl text-red-500" />,
    },
    {
      title: "Export-Ready Packaging",
      icon: <GiGlobe className="text-3xl text-red-500" />,
    },
  ];
  return (
    <>
      <section className="relative ">
        <div className="grid grid-cols-1 xl:mt-17">
          <Image
            src={FlatGlassBanner}
            alt="flat-glass"
            className="w-full h-full"
            priority={true}
          />
        </div>
        <div className=" breadcrumb">
          <ul className="flex items-center justify-center gap-2 p-2">
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm gap-1 text-red-600"
              >
                <HiHome />
                Home
              </Link>
            </li>
            <li className="text-sm text-gray-600">/</li>
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm text-gray-400"
              >
                Liquor Bottle
              </Link>
            </li>
          </ul>
        </div>
      </section>

      <section className="xl:py-[50px] pt-[50px] pb-[20px] px-6  xl:mb-5 mb-0">
        <div className="container mx-auto">
          <div className="grid  xl:grid-cols-2  grid-cols-1 gap-5 items-center transition ease-in-out duration-500">
            {/* Left Column */}
            <div>
              <h2 className="title !text-[#033b6f] !mb-0">
                Premium <span className="text-[#d42427]"> Glass </span>
                Bottles
              </h2>
              <h5 className="text-xl  font-semibold">
                for spirits & liquor packaging
              </h5>

              <div className="pt-5">
                <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3 text-justify">
                  Liquor packaging is more than just a container—it’s a{" "}
                  <span className="font-bold">
                    {" "}
                    statement of quality, heritage, and sophistication
                  </span>
                  . At <strong>Emerge Glass</strong>, we craft{" "}
                  <span className="span font-bold">
                    transparent glass liquor bottles
                  </span>{" "}
                  that elevate the identity of every spirit they hold. From{" "}
                  <strong>whiskey and rum to vodka and gin</strong>, our bottles
                  are trusted by India’s leading liquor brands for their{" "}
                  <span className="font-bold">
                    clarity, strength, and premium design appeal
                  </span>
                  .
                </p>
              </div>
            </div>

            <div className="">
              <video
                src="https://www.emergeglass.in/liquor_bottles.mp4"
                className="rounded-lg"
                autoPlay
                muted
                loop
                playsInline
              ></video>
            </div>
          </div>
        </div>
      </section>
      <section className="xl:py-[80px] !pt-[20px] pb-[50px] px-6">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-6">
            <div className="order-1 lg:order-2 bg-gradient-to-b from-red-50 to-blue-50 p-6 md:p-8 shadow-2xl h-auto lg:h-[90%]  relative z-40 lg:-ml-[20%] rounded-lg border-b-4 border-red-400 flex flex-col justify-center">
              <h2 className="title !text-[#033b6f] !text-center !text-2xl">
                Our <span className="text-[#d42427]"> Liquor Bottle </span>
                Range
              </h2>

              <p className="mb-5">
                <span className="font-semibold text-[#003049]">
                  We specialize in manufacturing a wide variety of bottles
                  tailored for the liquor industry:
                </span>
              </p>

              <ul className="flex flex-col gap-4 text-sm md:text-base text-gray-700 leading-relaxed">
                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Transparent Whiskey Bottles –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      Elegant designs with superior strength
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Transparent Rum Bottles –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      Durable bottles for dark and spiced rums
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Vodka & Gin Bottles –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      Sleek, modern shapes for premium branding
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Custom Liquor Bottles –
                    </span>
                    <span className="text-[#003049] font-semibold">
                      {" "}
                      Designed as per client requirements
                    </span>
                  </p>
                </li>
              </ul>
            </div>

            <Image
              src={GlassImg}
              alt="factory image"
              loading="lazy"
              className="order-2 lg:order-1 rounded-lg relative z-10 w-full h-auto "
            />
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden ">
        <Image
          src={CtbBanner}
          alt="call to action banner"
          className="w-full xl:h-[450px] md:h-[400px] h-[500px] object-cover"
          loading="lazy"
        />

        <div className="absolute inset-0 bg-black/60 z-10"></div>

        <div className="absolute inset-0 xl:w-full w-[92%] xl:left-0 left-1/2 xl:translate-x-0 -translate-x-1/2 flex items-start justify-center z-20 flex-col container mx-auto ">
          <h2 className="xl:text-4xl text-2xl font-bold text-left text-[#fff] mb-5">
            Why Choose Emerge Glass{" "}
            <span className="text-red-400">Liquor Bottles?</span>
          </h2>

          <ul className="mt-5 flex flex-wrap justify-center gap-4 text-gray-300 xl:w-[60%]">
            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Premium Look & Feel
                </span>
                <br />
                Enhances the identity of every spirit
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Strength & Durability
                </span>
                <br />
                Built to withstand transport & handling
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Crystal Transparency{" "}
                </span>
                <br />
                Highlights the purity of the liquor
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Design Flexibility{" "}
                </span>
                <br />
                Standard or custom shapes available
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 md:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Sustainable Packaging{" "}
                </span>
                <br />
                100% recyclable, eco-friendly glass
              </p>
            </li>
          </ul>
        </div>
      </section>

      <section className="py-[50px] px-[20px] bg-gradient-to-t from-red-900 to-transparent">
        <div className="container mx-auto">
          <h2 className="title !text-[#033b6f] !text-center">Applications</h2>

          <ul className="grid xl:grid-cols-4 md:grid-cols-2 gap-8">
            {categories.map((item, index) => (
              <li
                key={index}
                className="group flex items-center gap-4 xl:p-6 p-2 bg-gray-50 rounded-xl border border-gray-200 shadow-sm
                 transition duration-300 ease-out
                 hover:bg-white hover:ring-2 hover:ring-red-200 hover:shadow-md hover:scale-[1.03]"
              >
                <div className="p-3 bg-red-100 rounded-full transition-colors duration-300 group-hover:bg-red-200">
                  {item.icon}
                </div>
                <p className="text-gray-700 font-medium transition-colors duration-300 group-hover:text-red-600">
                  {item.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <section className=" relative bg-gradient-to-b from-white to-[#fbf9f5]">
        <LiquorClients />
        <LiquorClientsMobile />
      </section>

     <section className=" py-[50px] xl:pb-[100px] px-4 md:px-0 relative bg-gradient-to-b from-gray-800 to-[#fbf9f5]">
        <div className="">
          <h2 className="title !text-[#fff] !mb-5 !text-center">
            Explore <span className="text-[#d42427]"> More </span>
            Products
          </h2>

          <MoreToExplore />
          <MoreToExploreMobile />
        </div>
      </section>

      {/* <section className=" bg-[url(../../public/assets/background/bg_factory.png)] bg-cover bg-center">
        <div className="container mx-auto">
          <div className="grid grid-cols-1">
            <Image src={GlassImg} alt="factory image" loading="lazy" />
              <div className="bg-white min-h-[80vh] p-5 border-t-4 border-white border ">
            <ul className="flex flex-col gap-4 text-sm text-gray-700 leading-relaxed">
              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    Installed Capacity
                  </span>
                  <span className="text-red-500 font-semibold text-base">
                    {" "}
                    210 Ton/Day
                  </span>
                </p>
              </li>

              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    Packed Tonnage
                  </span>

                  <span className="text-red-500 font-semibold text-base">
                    {" "}
                    180 Ton/Day
                  </span>
                </p>
              </li>

              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    IS Machine:
                  </span>
                  Brand new machine from Sanjin
                  <span className="italic"> [Bucher Emhart Glass]</span>,
                  designed to produce
                  <span className="font-semibold">
                    {" "}
                    210 tons of high-quality container glass per day
                  </span>
                  for Narrow Neck bottles and Wide Mouth Jars.
                </p>
              </li>

              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    Manufacturing:
                  </span>
                  Container glass production across three categories — from
                  design to production — including ornamentation of premium
                  glass containers.
                </p>
              </li>

              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    Innovation:
                  </span>
                  Pioneering ultra-thin glass production in India, setting
                  superior benchmarks and creating value not only for ourselves
                  but also for the industry.
                </p>
              </li>
            </ul>
          </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default LiquorBottles;
